import { Link } from 'react-router-dom';
import './health.scss';

export default function KeyMotivator() {
  return (
    <>
      <h5>Key Motivator for Health Companies</h5>
      <p>Easier targeting would be health companies’ top motivator for increasing direct mail use going forward.</p>
      <ul>
        <li>The <strong><a href="/../every-door-direct-mail-101-an-introduction-for-businesses/">Every Door Direct Mail<sup className='key-motivator-symbol'>&reg;</sup> service</a></strong> makes it easy to reach prospects in your local community.</li>
      </ul>
    </>
  );
}
